import React from 'react';
import Style from './About.module.scss';
import { Box } from '@mui/material';
import RichText from '../RichText';
import { info } from '../../assets/info/Info';

// Shared bullet list. Each item is { label, note? } — the note wraps onto its
// own line underneath, indented past the bullet.
function BulletList({ items }) {
  return (
    <ul className={Style.bulletList}>
      {items.map((item, index) => (
        <li key={index}>
          <span className={Style.label}>{item.label}</span>
          {item.note && <span className={Style.note}>{item.note}</span>}
        </li>
      ))}
    </ul>
  );
}

export default function About() {
  const movies = info.favoriteMovies.map((movie) => ({
    label: `${movie.title} (${movie.year})`,
    note: movie.note,
  }));

  const teams = info.teams.map((team) => ({
    label: team.league ? `${team.name} (${team.league})` : team.name,
    note: team.note,
  }));

  return (
    <Box component={'main'} className={Style.about}>
      {info.about.map((paragraph, index) => (
        <p key={index}>
          <RichText text={paragraph} />
        </p>
      ))}

      <h2 className={Style.heading}>Interests</h2>
      <p className={Style.interests}>
        {info.hobbies
          // Non-breaking spaces inside each label, so a multi-word interest
          // like "rts games" wraps to the next line whole instead of splitting.
          .map((hobby) => hobby.label.toLowerCase().replace(/ /g, ' '))
          .join(', ')}
      </p>

      <Box className={Style.lists}>
        <Box>
          <h2 className={Style.heading}>Favorite Movies</h2>
          <BulletList items={movies} />
        </Box>
        <Box>
          <h2 className={Style.heading}>Teams I Support</h2>
          <BulletList items={teams} />
        </Box>
      </Box>
    </Box>
  );
}
